import { archiveStats } from '@/mocks/home';

const toneMap: Record<string, { value: string; unit: string; bar: string }> = {
  primary: { value: 'text-primary-600', unit: 'text-primary-500', bar: 'bg-primary-500' },
  accent: { value: 'text-accent-700', unit: 'text-accent-600', bar: 'bg-accent-500' },
  secondary: { value: 'text-secondary-800', unit: 'text-secondary-600', bar: 'bg-secondary-500' },
  foreground: { value: 'text-foreground-900', unit: 'text-foreground-600', bar: 'bg-foreground-800' },
};

export default function StatsStrip() {
  return (
    <section className="border-b border-background-200 bg-primary-950">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="flex flex-col divide-y divide-background-50/10 sm:flex-row sm:divide-x sm:divide-y-0">
          {archiveStats.map((stat) => {
            const tone = toneMap[stat.tone] ?? toneMap.foreground;
            return (
              <div
                key={stat.label}
                className="flex flex-1 items-center gap-4 py-5 sm:justify-center sm:px-4 md:py-6"
              >
                <span className={`h-8 w-1 rounded-full ${tone.bar}`}></span>
                <div>
                  <p className="flex items-baseline gap-1">
                    <span className={`font-heading text-2xl font-black tracking-tight md:text-3xl ${tone.value}`}>
                      {stat.value}
                    </span>
                    <span className={`font-label text-xs ${tone.unit}`}>{stat.unit}</span>
                  </p>
                  <p className="mt-1 font-label text-xs tracking-wide text-background-300">{stat.label}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}